// ─────────────────────────────────────────────────────────────────────────────
// L'élision de « de » devant un nom glissé dans un texte (11 octobre 2026).
//
// Un texte français écrit « Les électeurs de {nom} » ; avec « Édouard
// Philippe », l'écran lisait « Les électeurs de Édouard Philippe ». Une
// vingtaine de textes ont la même forme (« la fiche de {nom} », « le public de
// {nom} », « la photo de {nom} ») : la règle se pose une fois, sur ce que rend
// chaque traduction, plutôt que texte par texte.
//
// « de » devient « d’ » devant une voyelle, accentuée ou non. Pas devant un
// « h » (« de Hugo », h aspiré ou non, ne se devine pas) ni un « y » (« de
// YouTube »). Seulement le mot « de » entier : « monde Orion » ne bouge pas.
// ─────────────────────────────────────────────────────────────────────────────

const DE_DEVANT_VOYELLE = /(?<!\p{L})([Dd])e (?=[aeiouàâäéèêëîïôöùûüœæAEIOUÀÂÄÉÈÊËÎÏÔÖÙÛÜŒÆ])/gu;

/** « de Édouard » devient « d’Édouard », « de Orion » « d’Orion » ; le reste ne change pas. */
export function eliderLesDe(texte: string): string {
  return texte.replace(DE_DEVANT_VOYELLE, '$1’');
}
